"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InvitationDetailsAddressComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var InvitationDetailsAddressComponent = function InvitationDetailsAddressComponent(_ref) {
  var address = _ref.address;
  return /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Static"
  }, address.address_line_1 === 'xx' ? 'Alyce research address' : [address.address_line_1, address.address_line_2, address.city, address.state, address.zip].filter(function (addressField) {
    return !!addressField;
  }).join(', '));
};

exports.InvitationDetailsAddressComponent = InvitationDetailsAddressComponent;
InvitationDetailsAddressComponent.propTypes = {
  address: _propTypes.default.shape({
    address_line_1: _propTypes.default.string,
    address_line_2: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    zip: _propTypes.default.string
  }).isRequired
};
var _default = InvitationDetailsAddressComponent;
exports.default = _default;